export enum SocketEvents {
  updateTables = "updateTables",
  updateReservation = "updateReservation",
  updateTablesAndReservation = "updateTablesAndReservation",
}
